import type { ScheduleTime, Scheduling } from '@src/core/buyerApiClient';

export function mergeTimesFromSchedulings(schedulings: Scheduling[]): ScheduleTime[] {
  const byMinutes = new Map<number, ScheduleTime>();

  for (const scheduling of schedulings) {
    for (const time of scheduling.availableScheduleTimes ?? []) {
      byMinutes.set(time.minutes, time);
    }
  }

  return [...byMinutes.values()];
}
